import { ProgressionStatus } from '../types/olympicsListableEvent';

export async function sendFeedback(
  insight: string,
  feedbackType: 'positive' | 'neutral' | 'negative',
  eventId: string,
  timestamp: string,
  progressStatus: ProgressionStatus,
  urls: string[],
): Promise<Response> {
  // Determine environment (production vs development)
  const isProduction = process.env.REACT_APP_DEPLOY_ENV === 'prod';

  const formParameters = {
    dev: {
      pakkiAppId: '52e5c877-1dd6-4795-9133-ec6506c6c2c4',
      formKeys: {
        answerOption: '785fd1a6-19fe-4925-85e8-c04c963e072b',
        insight: 'f086c238-62bb-482b-affd-bc1ad6134f3b',
        eventId: '07b2688f-aa1a-4f2f-8da8-33601f7ebf91',
        timestamp: 'a8fdce57-6b0a-488c-b67b-89d1d6ff3040',
        progressStatus: '2923f3c4-d084-49f8-b368-19e28d958b6a',
        urls: 'e3cf2058-717c-45ee-a9e7-4fefb387e754',
      },
      formAnswerOptions: {
        positive: 'f8193649-cece-4784-b51a-f398c1a329c9',
        neutral: '768f3628-11d6-4f9d-99f4-2536a8a5db64',
        negative: '8be84b2f-1d5d-4bc3-bc67-048e765e5eb0',
      },
    },
    prod: {
      pakkiAppId: '97a872be-1524-4f11-a85d-521a804db40a',
      formKeys: {
        answerOption: 'cb9fbe8d-9455-4235-ae62-4cf19ff19717',
        insight: '5d78665f-2919-4be4-a478-f33d91b00829',
        eventId: '1dbc8ba9-e0b1-4c2b-9d31-f316e87fba15',
        timestamp: '23514ce2-3916-4864-a4ba-4b0594c6300d',
        progressStatus: 'f76b2adf-a67c-4ec8-9e67-323b2fdc8387',
        urls: '7a9095e5-abb4-4260-bc43-8b89c127fbfc',
      },
      formAnswerOptions: {
        positive: '311f4e8b-5e06-449a-8f06-609297ad02ca', // Hyödyllinen
        neutral: '9106a8b0-b830-4a69-822f-48298d8c5cb1', // Neutraali
        negative: '32c6472d-800c-4f29-81dd-df0e68054c3a', // Turha
      },
    },
  };

  // Select configuration based on environment
  const env = isProduction ? 'prod' : 'dev';
  const { pakkiAppId, formKeys, formAnswerOptions } = formParameters[env];

  // Previous values:
  // pakkiAppId: 'ea728acf-e7b1-4415-a429-4ad066905fd0'
  // formKeys (partial): {
  //   answerOption: '785fd1a6-19fe-4925-85e8-c04c963e072b',
  //   insight: 'f086c238-62bb-482b-affd-bc1ad6134f3b',
  // }
  // formAnswerOptions: {
  //   positive: 'f8193649-cece-4784-b51a-f398c1a329c9',
  //   neutral: '768f3628-11d6-4f9d-99f4-2536a8a5db64',
  //   negative: '8be84b2f-1d5d-4bc3-bc67-048e765e5eb0',
  // }

  const response = await fetch(`https://pakki.datadesk.hs.fi/api/public/forms/${pakkiAppId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      appVersion: 0,
      answers: {
        [formKeys.answerOption]: formAnswerOptions[feedbackType], // vastausvaihtoehto
        [formKeys.insight]: insight, // insight
        [formKeys.eventId]: eventId, // eventid
        [formKeys.timestamp]: timestamp, // iso-timestamp
        [formKeys.progressStatus]: progressStatus, // ProgressStatus
        [formKeys.urls]: urls.join('XXSEPARATEYY'), // urls separated by custom delimiter
      },
    }),
  });

  return response;
}
